import { useCallback } from 'react';
import { useLanguage } from './useLanguage';
import { buildLangPath } from '@/components/LangWrapper';

/**
 * Returns a function that prefixes paths with the current language.
 *
 * Usage:
 *   const lp = useLocalizedPath();
 *   <Link to={lp('/blog/blind-spots')}>...</Link>
 *
 * When language is 'pl': /pl/blog/blind-spots
 * When language is 'en': /blog/blind-spots (no prefix)
 */
export function useLocalizedPath() {
  const { currentLanguage } = useLanguage();

  return useCallback(
    (path: string) => buildLangPath(path, currentLanguage),
    [currentLanguage]
  );
}
